import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Button, FormLayout, Heading, Input } from "@/ui";
import { useForm, useValidator } from "@/hooks";
import styles from "./AlpineIOForm.module.scss";

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const FavoriteStoreAlpineIOForm = ({
    app,
    handleCancel,
    handlerUpdatingOrCreate,
    isCreate,
    isUpdating,
    selectStore,
    setStore,
}) => {
    const [isFormReset, resetFormInputs] = useState(isCreate);
    const { inputs, inputChange, setInputs } = useForm();

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "id",
                method: "isEmpty",
                validWhen: false,
                message: "This Store id is required.",
            },
            {
                field: "name",
                method: "isEmpty",
                validWhen: false,
                message: "This Store name is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    useEffect(() => {
        if (!isCreate) {
            const objSelect = app?.favorites_stores[selectStore];
            setInputs({
                id: objSelect?.id,
                name: objSelect?.name,
            });
        }
    }, []);

    if (!isCreate && !isFormReset) {
        resetFormInputs(true);
    }

    const createOrUpdate = async () => {
        if (isSubmited) {
            isSubmited(true);
        }

        if (isValid()) {
            const favStores = _.cloneDeep(app.favorites_stores);

            if (isCreate) {
                favStores.push({
                    id: inputs.id,
                    name: inputs.name,
                });
            } else {
                favStores[selectStore] = inputs;
            }
            setStore(favStores);
            handlerUpdatingOrCreate(favStores);
        }
    };

    const handleClose = () => {
        handleCancel();
        resetFormInputs(false);
    };

    return (
        <div className={styles.storeForm}>
            <Heading level={5}>
                {isCreate ? "Add Favorite Store" : "Update Favorite Store"}
            </Heading>

            <FormLayout>
                <FormLayout.Grid columns={2} maxWidth="twoThirds">
                    <Input
                        error={fieldError(validator, "id")}
                        fullWidth
                        label="Store Id"
                        name="id"
                        onChange={inputChange}
                        placeholder="Store id"
                        type="number"
                        value={inputs.id || ""}
                    />
                    <Input
                        error={fieldError(validator, "name")}
                        fullWidth
                        label="Store Name"
                        name="name"
                        onChange={inputChange}
                        placeholder="Store name"
                        value={inputs.name || ""}
                    />
                </FormLayout.Grid>
            </FormLayout>

            <div className={styles.storeActions}>
                <Button
                    disabled={isUpdating}
                    onClick={handleClose}
                    type="button"
                    variant="secondary"
                >
                    Cancel
                </Button>
                <Button
                    loading={isUpdating}
                    onClick={createOrUpdate}
                    type="button"
                >
                    Save
                </Button>
            </div>
        </div>
    );
};

export default FavoriteStoreAlpineIOForm;
